// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as MainPricingRouteImport } from './routes/_main/pricing'
import { Route as MainPortfolioRouteImport } from './routes/_main/portfolio'
import { Route as MainContactRouteImport } from './routes/_main/contact'
import { Route as MainAboutRouteImport } from './routes/_main/about'
import { Route as LegalTermsRouteImport } from './routes/_legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/_legal/privacy'

const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/$.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/services/index.lazy').then((d) => d.Route))
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/blog/index.lazy').then((d) => d.Route))
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/services/$slug.lazy').then((d) => d.Route))
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/blog/$slug.lazy').then((d) => d.Route))
const MainPricingRoute = MainPricingRouteImport.update({
            id: '/_main/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_main/pricing.lazy').then((d) => d.Route))
const MainPortfolioRoute = MainPortfolioRouteImport.update({
            id: '/_main/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_main/portfolio.lazy').then((d) => d.Route))
const MainContactRoute = MainContactRouteImport.update({
            id: '/_main/contact',path: '/contact',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_main/contact.lazy').then((d) => d.Route))
const MainAboutRoute = MainAboutRouteImport.update({
            id: '/_main/about',path: '/about',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_main/about.lazy').then((d) => d.Route))
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/_legal/terms',path: '/terms',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_legal/terms.lazy').then((d) => d.Route))
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/_legal/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_legal/privacy.lazy').then((d) => d.Route))

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,MainAboutRoute: MainAboutRoute,MainContactRoute: MainContactRoute,MainPortfolioRoute: MainPortfolioRoute,MainPricingRoute: MainPricingRoute,BlogSlugRoute: BlogSlugRoute,ServicesSlugRoute: ServicesSlugRoute,BlogIndexRoute: BlogIndexRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)